module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/name/suffix.js
// module id = 1263
// module chunks = 1